import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Button, ResponsiveSheet} from '@chekinapp/ui';
import {AUTH_LOGIN_ROUTE} from 'routes/constants';
import {usePath} from 'hooks';

type LogoutModalSheetProps = {
  open: boolean;
  onClose: () => void;
};

function LogoutModalSheet({open, onClose}: LogoutModalSheetProps) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  const handleLogBackIn = () => {
    onClose();
    navigate(getFullPath(AUTH_LOGIN_ROUTE));
  };

  return (
    <ResponsiveSheet
      open={open}
      onClose={onClose}
      title={t('you_ve_been_logged_out')}
      description={t('auth.logged_out_subtitle')}
      className="lg:max-w-[420px]"
      contentClassName="sm:pt-8"
      closeOnOverlayClick
    >
      <Button className="w-full" onClick={handleLogBackIn}>
        {t('auth.log_back_in')}
      </Button>
    </ResponsiveSheet>
  );
}

export {LogoutModalSheet};
